import { connect } from 'react-redux'

import DocumentsSection from 'components/home-page/views/sections/documents'

const mapStateToProps = (state, ownProps) => ({
  meta: state.homePageRevision.revision.sections[ownProps.sectionId].meta,
  theme: state.homePageRevision.revision.sections[ownProps.sectionId].theme
})

export default connect(mapStateToProps)(DocumentsSection)
